import moment from "moment-jalaali";
import { FormattedMessage } from "react-intl";
import FileSaver from "file-saver";

export const persianDateFormat = (date: string) => {
  return moment(date, "YYYYY-M-D HH:mm:ss").format("jYYYY/jM/jD");
};

export const convertToServerFormat = function (time: any) {
  if (time) {
    const moonLanding = new Date(`${time.$d}`); //  1- Wed Jul 20 2022 11:27:40 GMT+0430 (Iran Daylight Time)
    const T1 = moonLanding.toLocaleString("en-US", { timeZone: "UTC" }); // 2- 7/20/2022, 6:57:40 AM
    return moment(T1, "MM/DD/YYYY, HH:mm:ss").format(
      "YYYY-MM-DDTHH:mm:ss.SSSS[Z]"
    );
    // 3- 2022-07-20T06:57:40.0000Z
  }
};

export const handleProductActionInfo = (
  name: string,
  sku: string,
  manufacturerId: string,
  creationTime: string,
  // warehouseId: number = 404
  warehouseId: string
) => {
  return {
    "productionActionInfo.productName": name,
    "productionActionInfo.sku": sku,
    "productionActionInfo.manufatureName": manufacturerId,
    "productionActionInfo.creationDate": creationTime,
    // "productionActionInfo.currentWarehouseName": warehouseName(warehouseId),
    "productionActionInfo.currentWarehouseName": warehouseId,
  };
};

export const handleMassageResult = (
  action: string | null,
  status: string | null
) => {
  switch (true) {
    case action === "towarehouse":
      return {
        title: "با موفقیت به محصولات اضافه شد",
        subTitle: "",
      };

    case action === "exit":
      return {
        title: "با موفقیت از محصولات کم شد",
        subTitle: "",
      };

    case action === "transfer":
      return {
        title: "در خواست شما با موفقیت ثبت شد",
        subTitle: "",
      };

    default:
      return {};
  }
};

export const filterParams = (params: any) => {
  const arr1: any = [];
  Object.entries(params).map((item: any) => {
    if (item[1] !== undefined) {
      arr1.push(item);
    }
  });

  var obj = arr1.reduce(function (o: any, val: any) {
    const newVal1 = typeof val[1] === "string" ? val[1].trim() : val[1];
    o[val[0]] = newVal1;
    return o;
  }, {});

  return obj;
};

export const handleQueriesString = (params: any) => {
  const str = "";
  const result = Object.entries(params).map((item: any) =>
    str.concat(`${item[0]}=${item[1]}&`)
  );
  let concatArr = result.join("");
  return concatArr;
};

export const handleTypesName = (id: number) => {
  switch (id) {
    case 0:
      return <FormattedMessage id="type.Transfer" />;
    case 100:
      return <FormattedMessage id="type.Purchase" />;
    case 200:
      return <FormattedMessage id="type.Borrow" />;
    case 300:
      return <FormattedMessage id="type.Reserve" />;
    case 310:
      return <FormattedMessage id="type.UnReserve" />;
    case 400:
      return <FormattedMessage id="type.Faulty" />;
    case 401:
      return <FormattedMessage id="type.wrongInventory" />;
    case 402:
      return <FormattedMessage id="type.returnToDesigner" />;
    case 500:
      return <FormattedMessage id="type.Return" />;
    case 600:
      return <FormattedMessage id="type.Shipment" />;
    default:
      return "-------";
  }
};

export const generateExportedFile = (response: any, format: string) => {
  const blob = new Blob([response], {
    type: "application/octet-stream;charset=utf-8",
  });
  const fileSuffix =
    format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "docx";
  return FileSaver.saveAs(blob, `productReport.${fileSuffix}`);
};
